import { render, staticRenderFns } from "./DeductRecordManagement.vue?vue&type=template&id=6f330d4b&scoped=true"
import script from "./DeductRecordManagement.vue?vue&type=script&lang=js"
export * from "./DeductRecordManagement.vue?vue&type=script&lang=js"
import style0 from "./DeductRecordManagement.vue?vue&type=style&index=0&id=6f330d4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f330d4b",
  null
  
)

export default component.exports